import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchSolicitudInterna = ({ id_solicitud_pe }) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }

    setLoading(true)
    axios
      .get(`/listasolicitudes/${id_solicitud_pe}/`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { response, error, loading }
}

export default useFetchSolicitudInterna
